import PropTypes from 'prop-types';
import React from 'react';
import { Image, Button, ButtonGroup } from 'react-bootstrap';
import Avatar from 'react-avatar';
import Dropzone from 'react-dropzone';
import moment from 'moment';
import TourState from './TourState';
import TourEditModal from './TourEditModal';
import UploadDocuments from './widgets/UploadDocuments';
import UploadFormModal from './UploadFormModal ';
// import UploadFormModal from './UploadFormModal';

class TourHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      uploadFlag: false,
      uploadFileArry: null,
      groupFormpopup: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  componentDidMount() {
    this.props.requestTourManagers();
  }
  onDrop(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    this.props.editTourImage(this.props.tour.id, acceptedFiles);
  }
  getTourButtons(state, isTourManager, readyToActivate) {
    if (isTourManager) {
      return null;
    }
    const edit = (
      <Button bsStyle="default" bsSize="small" onClick={this.handleEdit}>
        <i className="fa fa-pencil" /> Edit
      </Button>
    );
    const activate = (
      <Button
        bsStyle="info"
        bsSize="small"
        onClick={this.handleClick}
        data-item="AC"
        title="Active tours are available to members using the mobile app."
      >
        <i className="fa fa-magic" /> Send to Tour Members
      </Button>
    );

    const archive = (
      <Button bsStyle="success" bsSize="small" onClick={this.handleClick} data-item="AR">
        <i className="fa fa-trash" /> Archive
      </Button>
    );
    const unarchive = (
      <Button bsStyle="success" bsSize="small" onClick={this.handleClick} data-item="DR">
        <i className="fa fa-trash" /> Unarchive
      </Button>
    );

    switch (state) {
      case 'DR':
        if (readyToActivate) {
          return (
            <ButtonGroup>
              {edit}
              {archive}
            </ButtonGroup>
          );
        }
        return (
          <ButtonGroup>
            {edit}
            {archive}
          </ButtonGroup>
        );
      case 'AC':
        return (
          <ButtonGroup>
            {edit}
            {archive}
          </ButtonGroup>
        );
      case 'AR':
        return <ButtonGroup>{unarchive}</ButtonGroup>;
      default:
        return null;
    }
  }
  handleClick(e) {
    e.preventDefault();
    const payload = {};
    payload.state = e.currentTarget.getAttribute('data-item');
    this.props.editTour(this.props.tour.id, payload);
  }
  handleEdit(e) {
    e.preventDefault();
    this.setState({
      show: true,
    });
  }
  closeModal() {
    this.setState({
      show: false,
      groupFormpopup: false,
    });
    window.location.reload();
  }
  handleGroupModel = () => {
    this.setState({
      groupFormpopup: true,
    });
  }
  renderImage(src) {
    if (src) {
      return (
        <Dropzone
          accept="image/*"
          ref={node => {
            this.dropzone = node;
          }}
          onDrop={this.onDrop}
          multiple={false}
          className="tour-image tour-image-details"
          acceptClassName="drop-accept"
          rejectClassName="drop-reject"
        >
          <Image src={src} responsive className="avatar" />
        </Dropzone>
      );
    }
    const style = { 'overflow': 'hidden', 'overflow-wrap': 'break-word' }
    return (
      <Dropzone
        accept="image/*"
        ref={node => {
          this.dropzone = node;
        }}
        onDrop={this.onDrop}
        multiple={false}
        className="tour-image tour-image-details"
        acceptClassName="drop-accept"
        rejectClassName="drop-reject"
      >
        <Avatar name={this.props.tour.name} style={style} color="#326a34" size={75} className="avatar" />
      </Dropzone>
    );
  }
  handleUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();
    input.onchange = (e) => {
      const file = e.target.files[0];
      // Handle the file as needed
      this.setState({
        uploadFlag: true,
        uploadFileArry: file
      })
    };
  };
  manageDate = () => {
    let start = Infinity;
    let end = -Infinity;
    const tourStops = this.props.tour.tour_stops;
  
    tourStops.forEach((data) => {
      const startDate = new Date(data.start);
      const endDate = new Date(data.end);
      
      if(data.events.length > 0){
        const gstartDate = new Date(data.events[0].start)
        const gendDate = new Date(data.events[0].end)
        if (startDate < start) {
          start = gstartDate<startDate?gstartDate:startDate
        }
        
        if (endDate > end) {
          end = gendDate>endDate?gendDate:endDate
        }
      }
    });
    // Format the dates back to strings if necessary
    const startStr = start === Infinity ? null : start.toISOString().split('T')[0];
    const endStr = end === -Infinity ? null : end.toISOString().split('T')[0];
  
    return {
      start: startStr,
      end: endStr
    };
  }
  
  render() {
    const Dates=this.manageDate()
    // const start = moment(this.props.tour.start);
    // const end = moment(this.props.tour.end);
    const start = moment(Dates.start)
    const end = moment(Dates.end)
    let tourDate = '';
    if (start.isValid()) {
      tourDate = `${start.format('MMMM Do YYYY')} - ${end.format('MMMM Do YYYY')}`;
    }
    let strTourManager = '';
    if (this.props.tour.primary_agent_profile) {
      strTourManager = this.props.tour.primary_agent_profile.first_name + ' ' + this.props.tour.primary_agent_profile.last_name
    }
    let contact_TourManager = '';
    if (this.props.tour.primary_agent_profile) {
      contact_TourManager = this.props.tour.primary_agent_profile.profile.mobile;
    }

    let iata = '';
    if (this.props.tour.iata) {
      iata = this.props.tour.iata;
    }
    const image = this.renderImage(this.props.tour.image);
    const readyToActivate =
      this.props.tour.members.length > 0 && this.props.tour.tour_stops.length > 0;
    const tourButtons = this.getTourButtons(
      this.props.tour.state,
      this.props.isTourManager,
      readyToActivate
    );
    return (
      <div>
        <div className="tour-header container-fuild">
          {image}
          <div className="tour-title">
            <h2>
              {this.props.tour.name}: <span>{this.props.tour.tag_line}</span>
            </h2>
            <div className="tour-info">
              <div className="tour-date">
                {tourDate} <TourState state={this.props.tour.state} />
                &nbsp;&nbsp;<p className="tour-header-iata-number">IATA# {iata}</p>
              </div>
              <div className='groupBtn'>
                {tourButtons}
                <div className='uploadFormButton' >
                  <Button bsStyle="success formbtn" bsSize="small" onClick={this.handleGroupModel}>
                    <i className="fa fa-file-code-o" /> Manage Group Documents
                  </Button>
                </div>
              </div>
            </div>
            <div>
              <b>Travel Agent:&nbsp;</b>{strTourManager}
            </div>
            <div >
              <b>Contact:&nbsp;</b>{contact_TourManager}
            </div>
          </div>
          <div className="clearfix" />
          {this.state.groupFormpopup && (
            <UploadFormModal
              tour={this.props.tour}
              upload_type={'Tour Group'}
              show={this.state.groupFormpopup}
              onClose={this.closeModal} />
          )}
          {this.state.show && (
            <TourEditModal
              tour={this.props.tour}
              show={this.state.show}
              onClose={this.closeModal}
              addTour={this.props.addTour}
              editTour={this.props.editTour}
              requestTourManagers={this.props.requestTourManagers}
              tourManagers={this.props.tourManagers}
            />
          )}
        </div>
        {/* <div className='uploadButton'>
          <Button bsStyle="default" bsSize="small" onClick={this.handleUpload} >
            <i className="fa fa-file-code-o" /> <b>Upload File</b>
          </Button>
        </div> */}
      </div>

    );
  }
}

TourHeader.propTypes = {
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  addTour: PropTypes.func.isRequired,
  editTour: PropTypes.func.isRequired,
  editTourImage: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
};

TourHeader.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    // image: 'https://www.whyy.org/img/ontour_logocrop.png',
  },
};

export default TourHeader;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHeader.js